import React from 'react'
import CatalogueFilterLinkColor from './catalogue-filter-link-color'

const CatalogueFilterLinkList = ({list, filter, filterName, updateFilters, color}) => {

  const handleClick = event => {
    event.preventDefault();

    const value = event.target.textContent;

    const newFilter = value === filter ? '' : value;

    updateFilters(newFilter)
  };

  const itemList = list
    .map(title => (
      <li key={title}>
        <a className={filter.indexOf(title) > -1 ? "chosen" : undefined} href="/">
          {
            color ?
              (<CatalogueFilterLinkColor title={title}/>) :
              title
          }
        </a>
      </li>
    ));

  return (
    <ul onClick={handleClick}>
      {itemList}
    </ul>
  )
};

CatalogueFilterLinkList.defaultProps = {
  list: [],
  filter: []
};

export default CatalogueFilterLinkList
